(function() {
	'use strict';

	var locations = [
		{
			title: 'Unimech Flow Inc.',
			category: 'Sales Office',
			region: 'USA',
			description: '10511 Windsor Ln B110, Houston TX 77031',
			lat: 29.6685,
			lng: -95.5608,
			zoom: 5,
			email: 'info@unimechflow.com',
			phone: '(713) 885-6757'
		},
		{
			title: 'Unimech Group Bhd',
			category: 'Sales Office',
			region: 'Malaysia',
			description: 'Malaysia Headquarter',
			lat: 5.4141,
			lng: 100.3288,
			zoom: 6,
			link: 'https://www.unimechgroup.com/'
		},
		{
			title: 'PT Arita Prima Indonesia Tbk',
			category: 'Sales Office',
			region: 'Indonesia',
			description: '',
			lat: -6.2088,
			lng: 106.8456,
			zoom: 5,
			link: 'https://arita.co.id/'
		},
		{
			title: 'Unimech Vietnam Company Limited',
			category: 'Sales Office',
			region: 'Vietnam',
			description: '',
			lat: 10.8231,
			lng: 106.6297,
			zoom: 5
		},
		{
			title: 'Unimech Engineering Group (Thailand) Co.,Ltd.',
			category: 'Sales Office',
			region: 'Thailand',
			description: '',
			lat: 13.7563,
			lng: 100.5018,
			zoom: 5,
			link: 'https://www.unimechthailand.com/'
		},
		{
			title: 'Unimech (Asia Pacific) Pty Ltd',
			category: 'Sales Office',
			region: 'Australia',
			description: '',
			lat: -33.8688,
			lng: 151.2093,
			zoom: 4,
			link: 'https://www.unimech.com.au/'
		},
		{
			title: 'Unimech (Shanghai) Co., Ltd.',
			category: 'Sales Office',
			region: 'China',
			description: '',
			lat: 31.2304,
			lng: 121.4737,
			zoom: 5
		},
		{
			title: 'Arita Valve MFG (M) Sdn. Bhd.',
			category: 'Factory',
			region: 'Malaysia',
			description: 'Manufacturing Base',
			lat: 5.3833,
			lng: 100.3894,
			zoom: 7,
			link: 'https://www.aritavalve.com/'
		},
		{
			title: 'Arita Flow Control (Tianjin) Co., Ltd',
			category: 'Factory',
			region: 'China',
			description: 'Tianjin',
			lat: 39.3434,
			lng: 117.3616,
			zoom: 6,
			link: 'http://www.aritaflow.com/'
		},
		{
			title: 'LEVO Valve & Actuation Solutions (LVAS)',
			category: 'Distributor',
			region: 'Argentina',
			description: '2035 N Mason Rd. Ste 503, Katy TX 77449',
			lat: -34.6037,
			lng: -58.3816,
			zoom: 5,
			link: 'https://www.levo-group.com/'
		},
		{
			title: 'Novec Engineering and Contracting Inc.',
			category: 'Distributor',
			region: 'Egypt',
			description: 'Saray Capital Tower, El-Ekbal Street, Louran, Alexandria, Egypt 21500. Eng. Samy Sorour',
			lat: 31.2001,
			lng: 29.9187,
			zoom: 6,
			link: 'https://novec-eg.com/'
		}
	];

	var config = window.UnimechContactMapConfig || {};
	var leafletCssUrl = config.leafletCssUrl || 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
	var leafletJsUrl = config.leafletJsUrl || 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

	function loadStylesheet(url) {
		if (document.querySelector('link[href="' + url + '"]')) {
			return;
		}

		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = url;
		document.head.appendChild(link);
	}

	function loadScript(url, callback, errorCallback) {
		if (window.L) {
			callback();
			return;
		}

		var existing = document.querySelector('script[src="' + url + '"]');
		if (existing) {
			existing.addEventListener('load', callback);
			existing.addEventListener('error', errorCallback);
			return;
		}

		var script = document.createElement('script');
		script.src = url;
		script.async = true;
		script.onload = callback;
		script.onerror = errorCallback;
		document.head.appendChild(script);
	}

	function escapeHtml(value) {
		return String(value).replace(/[&<>"']/g, function(character) {
			return {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			}[character];
		});
	}

	function popupMarkup(location) {
		var actions = [];
		var showDescription = location.description && location.description !== location.region;
		if (location.link) {
			actions.push('<a href="' + escapeHtml(location.link) + '" target="_blank" rel="noopener">Visit website</a>');
		}
		if (location.email) {
			actions.push('<a href="mailto:' + escapeHtml(location.email) + '">' + escapeHtml(location.email) + '</a>');
		}
		if (location.phone) {
			actions.push('<a href="tel:+17138856757">' + escapeHtml(location.phone) + '</a>');
		}

		return [
			'<div class="unimech-map-popup is-' + location.category.toLowerCase().replace(/\s+/g, '-') + '">',
			'<span class="unimech-map-popup-type">' + escapeHtml(location.category) + '</span>',
			'<h3>' + escapeHtml(location.title) + '</h3>',
			'<p>' + escapeHtml(location.region) + '</p>',
			showDescription ? '<p>' + escapeHtml(location.description) + '</p>' : '',
			actions.length ? '<p>' + actions.join('<br>') + '</p>' : '',
			'</div>'
		].join('');
	}

	function buildList(root, map, markers) {
		var list = root.querySelector('[data-map-list]');
		if (!list) {
			return;
		}

		locations.forEach(function(location, index) {
			var item = document.createElement('div');
			var showDescription = location.description && location.description !== location.region;
			item.className = 'unimech-map-location is-' + location.category.toLowerCase().replace(/\s+/g, '-');
			item.innerHTML = [
				'<small>' + escapeHtml(location.category) + '</small>',
				'<strong>' + escapeHtml(location.title) + '</strong>',
				'<span>' + escapeHtml(location.region) + '</span>',
				showDescription ? '<span>' + escapeHtml(location.description) + '</span>' : '',
				location.link ? '<a class="unimech-map-link" href="' + escapeHtml(location.link) + '" target="_blank" rel="noopener">Visit website</a>' : '',
				'<button class="unimech-map-view" type="button">View on map</button>'
			].join('');

			function selectLocation() {
				var items = list.querySelectorAll('.unimech-map-location');
				for (var i = 0; i < items.length; i += 1) {
					items[i].classList.remove('is-active');
				}

				item.classList.add('is-active');
				map.setView([location.lat, location.lng], location.zoom || 5, { animate: true });
				markers[index].openPopup();
			}

			item.querySelector('.unimech-map-view').addEventListener('click', selectLocation);
			item.addEventListener('click', function(event) {
				if (event.target.tagName.toLowerCase() === 'a' || event.target.tagName.toLowerCase() === 'button') {
					return;
				}
				selectLocation();
			});

			list.appendChild(item);

			if (index === 0) {
				item.classList.add('is-active');
			}
		});
	}

	function initLeafletMap(root) {
		var canvas = root.querySelector('#unimech-contact-map');
		var reset = root.querySelector('[data-map-reset]');
		function markerIcon(location) {
			return L.divIcon({
			className: '',
			html: '<span class="unimech-map-pin is-' + location.category.toLowerCase().replace(/\s+/g, '-') + '"></span>',
			iconSize: [34, 34],
			iconAnchor: [17, 17],
			popupAnchor: [0, -18]
			});
		}

		var map = L.map(canvas, {
			center: [locations[0].lat, locations[0].lng],
			zoom: locations[0].zoom,
			scrollWheelZoom: false,
			worldCopyJump: true
		});

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors',
			maxZoom: 18
		}).addTo(map);

		var markers = locations.map(function(location) {
			return L.marker([location.lat, location.lng], { icon: markerIcon(location) })
				.addTo(map)
				.bindPopup(popupMarkup(location));
		});

		buildList(root, map, markers);
		markers[0].openPopup();

		if (reset) {
			reset.addEventListener('click', function() {
				map.setView([locations[0].lat, locations[0].lng], locations[0].zoom, { animate: true });
				markers[0].openPopup();
			});
		}

		setTimeout(function() {
			map.invalidateSize();
		}, 250);
	}

	function showFallback(root) {
		var canvas = root.querySelector('#unimech-contact-map');
		if (!canvas) {
			return;
		}

		canvas.className += ' is-fallback';
		canvas.innerHTML = '<div class="unimech-map-fallback-message">The interactive map is temporarily unavailable. Please contact us at <a href="mailto:info@unimechflow.com">info@unimechflow.com</a> or <a href="tel:+17138856757">(713) 885-6757</a> for the nearest authorized distributor.</div>';
	}

	function init() {
		var root = document.querySelector('[data-unimech-map]');
		if (!root) {
			return;
		}

		loadStylesheet(leafletCssUrl);
		loadScript(leafletJsUrl, function() {
			if (!window.L) {
				showFallback(root);
				return;
			}

			initLeafletMap(root);
		}, function() {
			showFallback(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
}());
